import { createReducer } from 'redux-act';
import actions from '../actions/financialYearActions';

const initialState = {
    addFinancialYearPending: false,
    addFinancialYearRes: null,
    addFinancialYearError: null,

    getAllFinancialYearPending: false,
    getAllFinancialYearRes: null,
    getAllFinancialYearError: null,

    updateFinancialYearPending: false,
    updateFinancialYearRes: null,
    updateFinancialYearError: null,

    getFinancialYearListPending: false,
    getFinancialYearListRes: null,
    getFinancialYearListError: null,

    getFinancialYearWiseMonthPending: false,
    getFinancialYearWiseMonthRes: null,
    getFinancialYearWiseMonthError: null,
};
/* Add FinancialYear Reducers */
const handleAddFinancialYearRequest = state => {
    return {
        ...state,
        ...{
            addFinancialYearPending: true,
            addFinancialYearRes: null,
            addFinancialYearError: null,
        },
    };
};
const handleAddFinancialYearSuccess = (state, payload) => {
    return {
        ...state,
        ...{
            addFinancialYearPending: false,
            addFinancialYearRes: payload,
            addFinancialYearError: null,
        },
    };
};
const handleAddFinancialYearError = (state, payload) => ({
    ...state,
    ...{
        addFinancialYearPending: false,
        addFinancialYearRes: null,
        addFinancialYearError: payload,
    },
});


/* Get All FinancialYear Reducers */
const handleGetAllFinancialYearRequest = state => {
    return {
        ...state,
        ...{
            getAllFinancialYearPending: true,
            getAllFinancialYearRes: null,
            getAllFinancialYearError: null,
        },
    };
};
const handleGetAllFinancialYearSuccess = (state, payload) => {
    return {
        ...state,
        ...{
            getAllFinancialYearPending: false,
            getAllFinancialYearRes: payload,
            getAllFinancialYearError: null,
        },
    };
};
const handleGetAllFinancialYearError = (state, payload) => ({
    ...state,
    ...{
        getAllFinancialYearPending: false,
        getAllFinancialYearRes: null,
        getAllFinancialYearError: payload,
    },
});


/* Update FinancialYear Reducers */
const handleUpdateFinancialYearRequest = state => {
    return {
        ...state,
        ...{
            updateFinancialYearPending: true,
            updateFinancialYearRes: null,
            updateFinancialYearError: null,
        },
    };
};
const handleUpdateFinancialYearSuccess = (state, payload) => {
    return {
        ...state,
        ...{
            updateFinancialYearPending: false,
            updateFinancialYearRes: payload,
            updateFinancialYearError: null,
        },
    };
};
const handleUpdateFinancialYearError = (state, payload) => ({
    ...state,
    ...{
        updateFinancialYearPending: false,
        updateFinancialYearRes: null,
        updateFinancialYearError: payload,
    },
});


/* Update FinancialYear Reducers */
const handleGetFinancialYearListRequest = state => {
    return {
        ...state,
        ...{
            getFinancialYearListPending: true,
            getFinancialYearListRes: null,
            getFinancialYearListError: null,
        },
    };
};
const handleGetFinancialYearListSuccess = (state, payload) => {
    return {
        ...state,
        ...{
            getFinancialYearListPending: false,
            getFinancialYearListRes: payload,
            getFinancialYearListError: null,
        },
    };
};
const handleGetFinancialYearListError = (state, payload) => ({
    ...state,
    ...{
        getFinancialYearListPending: false,
        getFinancialYearListRes: null,
        getFinancialYearListError: payload,
    },
});

/* get Financial Year Wise Month  Reducers */
const handleGetFinancialYearWiseMonthRequest = state => {
    return {
        ...state,
        ...{
            getFinancialYearWiseMonthPending: true,
            getFinancialYearWiseMonthRes: null,
            getFinancialYearWiseMonthError: null,
        },
    };
};
const handleGetFinancialYearWiseMonthSuccess = (state, payload) => {
    return {
        ...state,
        ...{
            getFinancialYearWiseMonthPending: false,
            getFinancialYearWiseMonthRes: payload,
            getFinancialYearWiseMonthError: null,
        },
    };
};
const handleGetFinancialYearWiseMonthError = (state, payload) => ({
    ...state,
    ...{
        getFinancialYearWiseMonthPending: false,
        getFinancialYearWiseMonthRes: null,
        getFinancialYearWiseMonthError: payload,
    },
});



/* Clear FinancialYear Store */
const clearFinancialYearStore = (state, payload) => {
    switch (payload) {
        case 'HANDLE_CLEAR_ADD_POSITION_STORE':
            return {
                ...state,
                ...{
                    addFinancialYearPending: false,
                    addFinancialYearRes: null,
                    addFinancialYearError: null,
                },
            };
        case 'HANDLE_CLEAR_UPDATE_POSITION_STORE':
            return {
                ...state,
                ...{
                    updateFinancialYearPending: false,
                    updateFinancialYearRes: null,
                    updateFinancialYearError: null,
                },
            };

        default:
            return state;
    }
};



export default createReducer(
    {
        [actions.addFinancialYearRequest]: handleAddFinancialYearRequest,
        [actions.addFinancialYearSuccess]: handleAddFinancialYearSuccess,
        [actions.addFinancialYearError]: handleAddFinancialYearError,

        [actions.getAllFinancialYearRequest]: handleGetAllFinancialYearRequest,
        [actions.getAllFinancialYearSuccess]: handleGetAllFinancialYearSuccess,
        [actions.getAllFinancialYearError]: handleGetAllFinancialYearError,

        [actions.updateFinancialYearRequest]: handleUpdateFinancialYearRequest,
        [actions.updateFinancialYearSuccess]: handleUpdateFinancialYearSuccess,
        [actions.updateFinancialYearError]: handleUpdateFinancialYearError,

        [actions.getFinancialYearListRequest]: handleGetFinancialYearListRequest,
        [actions.getFinancialYearListSuccess]: handleGetFinancialYearListSuccess,
        [actions.getFinancialYearListError]: handleGetFinancialYearListError,

        [actions.getFinancialYearWiseMonthRequest]: handleGetFinancialYearWiseMonthRequest,
        [actions.getFinancialYearWiseMonthSuccess]: handleGetFinancialYearWiseMonthSuccess,
        [actions.getFinancialYearWiseMonthError]: handleGetFinancialYearWiseMonthError,

        [actions.handleClearFinancialYearStore]: clearFinancialYearStore,
    },
    initialState,
);